(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["catalog-page"]) return;
  try {
    
  function filterCatalogProducts(inputEl) {
    if (!inputEl) return;

    var root = inputEl.closest('[data-catalog-root]');
    if (!root) return;

    var query = inputEl.value.trim().toLowerCase();
    var cards = root.querySelectorAll('[data-catalog-card]');

    cards.forEach(function (card) {
      var title = (card.getAttribute('data-title') || '').toLowerCase();
      card.hidden = query !== '' && title.indexOf(query) === -1;
    });
  }

  document.addEventListener('input', function (event) {
    var target = event.target;
    if (!target || !target.matches('.catalog-page__search')) return;
    filterCatalogProducts(target);
  });

  document.querySelectorAll('.catalog-page__search').forEach(function (inputEl) {
    filterCatalogProducts(inputEl);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    const kitsSearch = document.querySelector('[data-kits-search]');
    if (!kitsSearch) return;

    const input = kitsSearch.querySelector('.kits-search__input');
    if (!input) return;

    const cards = Array.from(document.querySelectorAll('.product-grid__item[data-product-title]'));

    const applyFilter = () => {
      const query = input.value.trim().toLowerCase();
      cards.forEach((card) => {
        const title = (card.dataset.productTitle || '').toLowerCase();
        card.hidden = query !== '' && !title.includes(query);
      });
    };

    input.addEventListener('input', applyFilter);
  });

  } catch(e) { console.error(e); }
})();
})();
